import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

$(document).ready(function(){
  let navLeft = $('.sec1-nav .nav a.active').offset().left - 30
  $('.sec1-nav .nav').scrollLeft(navLeft)
})

$('.case-list li .item-img,.case-list li .item-text').on('click',function(){
  let parents = $(this).closest('li')
  let album = parents.find('.item-album a')

  if( album.length > 0){
    album.eq(0).click()
  }
})